import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "fields", "destroyField"]

  connect() {
    this.refresh()
  }

  // Called when the user clicks the "Add a training day" checkbox.
  toggle() {
    this.refresh()
  }

  refresh() {
    if (!this.hasToggleTarget) return
    const enabled = this.toggleTarget.checked
    this.fieldsTarget.classList.toggle("hidden", !enabled)
    if (this.hasDestroyFieldTarget) {
      // When the toggle is off, mark the nested record for destruction
      // so existing training_day records get removed on save.
      this.destroyFieldTarget.value = enabled ? "0" : "1"
    }
  }
}
